import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EDITOR_LOAD_PAGE_SNAPSHOTS_BEGIN,
  EDITOR_LOAD_PAGE_SNAPSHOTS_SUCCESS,
  EDITOR_LOAD_PAGE_SNAPSHOTS_FAILURE,
  EDITOR_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadPageSnapshots(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_PAGE_SNAPSHOTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/page-snapshots/${projectId}/project/min`,
        header,
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_PAGE_SNAPSHOTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_PAGE_SNAPSHOTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPageSnapshotsError() {
  return {
    type: EDITOR_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_PAGE_SNAPSHOTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadPageSnapshotsPending: true,
        loadPageSnapshotsError: null,
      };

    case EDITOR_LOAD_PAGE_SNAPSHOTS_SUCCESS:
      // The request is success
      return {
        ...state,
        loadPageSnapshotsPending: false,
        loadPageSnapshotsError: null,
        showPageSnapshotName: false,
        pageSnapshots: action.data,
      };

    case EDITOR_LOAD_PAGE_SNAPSHOTS_FAILURE:
      // The request is failed
      return {
        ...state,
        loadPageSnapshotsPending: false,
        loadPageSnapshotsError: action.data.error,
      };

    case EDITOR_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadPageSnapshotsError: null,
      };

    default:
      return state;
  }
}
